import { RewardRowType } from "types/business/RewardRowType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = RewardRowType[];

export const useDefaultObservableRewardRowTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectRewardRowTypeArray extends BehaviorSubject<CurrentType> {}
